import { productsOps } from "../api/operations";
import { ROLE } from "../Auth/useRole";
import { entityFactory } from "../hooks/useEntity";
import { defineEntity } from "../api/entity";

export const conf = defineEntity({
  ...entityFactory("product"),
  endpoint: "products",
  operations: productsOps,
  roleView: [ROLE.PRODUCT_VIEW, ROLE.PRODUCT_ADMIN],
  roleAdmin: [ROLE.PRODUCT_ADMIN],
  baseRoute: "product",
  singularName: (t) => t("Product"),
  name: (t) => t("Products"),
  infiniteNormalizer: (value) => {
    return {
      ...value,
      results: value.results.map((v) => ({
        ...v,
        id: v.id,
        name: v.partNumber + " | " + v.variant + " | " + v.type,
      })),
    };
  },
});

export default conf;
